export const STANDARD_AGENT_MESSAGE_DRAFT_MAX_LENGTH = 300;
export const ANSWER_MESSAGE_DRAFT_MAX_LENGTH = 2_000;
/** Return Unicode scalar count, or null for an unpaired UTF-16 surrogate. */
export function unicodeScalarLength(value) {
    let length = 0;
    for (let index = 0; index < value.length; index += 1) {
        const unit = value.charCodeAt(index);
        if (unit >= 0xd800 && unit <= 0xdbff) {
            const next = value.charCodeAt(index + 1);
            if (!(next >= 0xdc00 && next <= 0xdfff))
                return null;
            index += 1;
        }
        else if (unit >= 0xdc00 && unit <= 0xdfff) {
            return null;
        }
        length += 1;
    }
    return length;
}
export function isUnicodeScalarTextWithinLength(value, maximumLength) {
    const length = unicodeScalarLength(value);
    return length !== null && length <= maximumLength;
}
/** Preserve a valid string exactly when it fits; otherwise cut only between
 * Unicode scalars. Invalid UTF-16 is never converted into different text. */
export function unicodeScalarPrefix(value, maximumLength) {
    if (!Number.isSafeInteger(maximumLength) || maximumLength < 0) {
        throw new RangeError("Unicode scalar prefix length must be a non-negative safe integer.");
    }
    const length = unicodeScalarLength(value);
    if (length === null)
        return null;
    if (length <= maximumLength)
        return value;
    if (maximumLength === 0)
        return "";
    let end = 0;
    let retained = 0;
    for (const scalar of value) {
        end += scalar.length;
        retained += 1;
        if (retained === maximumLength)
            return value.slice(0, end);
    }
    return value;
}
/**
 * ANSWER_MESSAGE carries Luna's arbitrary audience-scoped answer, while every
 * other outbound proposal remains the existing compact operational message.
 *
 * WHY [BOL-ANSWER-DRAFT-LENGTH-001]: applying the old 300-character send-draft
 * cap to an otherwise valid semantic ANSWER made a 301-2,000 character model
 * result fail only when its Manual proposal reached PostgreSQL. JavaScript and
 * HTML count UTF-16 units while PostgreSQL length() counts Unicode scalars, so
 * raw string.length also made one emoji boundary disagree across owners.
 * Truncation would lose meaning and proof; widening every message would weaken
 * the compact clarification/follow-up contract. Keep one scalar-valid count at
 * the proposal-type owner and reuse it at Domain, persistence, API, and Review.
 * Falsifier: a >300 ANSWER is rejected/truncated, or a >300 clarification or
 * follow-up becomes valid. A valid <=2,000-scalar answer must also survive a
 * Text/Voice history projection even when its UTF-16 length exceeds 2,000.
 */
export function agentProposalMessageDraftMaxLength(type) {
    return type === "ANSWER_MESSAGE"
        ? ANSWER_MESSAGE_DRAFT_MAX_LENGTH
        : STANDARD_AGENT_MESSAGE_DRAFT_MAX_LENGTH;
}
export function isAgentProposalMessageDraftWithinBound(type, value) {
    return isUnicodeScalarTextWithinLength(value, agentProposalMessageDraftMaxLength(type));
}
//# sourceMappingURL=proposal-message-draft.js.map